import localDb from '../local-db';
import { isBrowser } from '../device-type';

export const storage = localDb('appshell');

export const appShellDataUrl = '/appshell/data';

export function nukeAppShell() {
  // The catch is because it always fails in private browsing
  return storage.clear().catch(() => null);
}
// This is used in _Splashscreen.html
if (isBrowser()) {
  window.nukeAppShellData = nukeAppShell;
}

export function saveAppShellData<TAppShell extends Scope.AppShellDataBase>(data: TAppShell) {
  // The catch is because it always fails in private browsing
  return storage.setItem(appShellDataUrl, data).catch(() => null);
}

export let appShellComponentName: string | null = null;
export function setAppShellComponentName(name: string) {
  appShellComponentName = name;
}

// Note! This shouldn't be used by the main application since the app shell data
// is available in the Redux state.
export function getAppShellData(): Promise<Scope.AppShellDataBase> {
  return storage.getItem<Scope.AppShellDataBase>(appShellDataUrl).then(data => {
    if (data) {
      return data;
    } else {
      return fetch(appShellDataUrl, { credentials: 'same-origin' })
        .then(r => r.json())
        .then((json: any) => {
          saveAppShellData(json);
          return json;
        });
    }
  });
}
